export enum FeatureFlags {
  AuthDapp = 'dapps-auth-dapp',
}
